export const SET_QUEST_PATH = "SET_QUEST_PATH";
export const SET_CURRENT_TOPIC = "SET_CURRENT_TOPIC";